import React from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiGift, FiMail, FiTwitter, FiInstagram, FiFacebook, FiHeart } = FiIcons;

    const Footer = () => {
      return (
        <footer className="bg-gray-900 text-white py-16 px-6">
          <div className="container mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
              {/* Logo & Description */}
              <div className="md:col-span-2">
                <div className="flex items-center space-x-2 mb-6">
                  <div className="w-10 h-10 bg-gradient-to-br from-rose-primary to-rose-secondary rounded-xl flex items-center justify-center">
                    <SafeIcon icon={FiGift} className="text-white text-xl" />
                  </div>
                  <span className="text-2xl font-bold bg-gradient-to-r from-rose-primary to-rose-secondary bg-clip-text text-transparent">
                    Gifter's Choice
                  </span>
                </div>
                <p className="text-gray-300 mb-6 max-w-md">
                  The ultimate gift list app that makes gift giving effortless. Create, share, and let your gifters choose what matters most.
                </p>
                <div className="flex space-x-4">
                  <motion.a href="#" whileHover={{ scale: 1.1 }} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-rose-primary transition-colors">
                    <SafeIcon icon={FiTwitter} className="text-lg" />
                  </motion.a>
                  <motion.a href="#" whileHover={{ scale: 1.1 }} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-rose-primary transition-colors">
                    <SafeIcon icon={FiInstagram} className="text-lg" />
                  </motion.a>
                  <motion.a href="#" whileHover={{ scale: 1.1 }} className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-rose-primary transition-colors">
                    <SafeIcon icon={FiFacebook} className="text-lg" />
                  </motion.a>
                </div>
              </div>
              {/* Quick Links */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li><a href="/#features" className="text-gray-300 hover:text-rose-primary transition-colors">Features</a></li>
                  <li><a href="/#how-it-works" className="text-gray-300 hover:text-rose-primary transition-colors">How It Works</a></li>
                  <li><a href="/#download" className="text-gray-300 hover:text-rose-primary transition-colors">Download</a></li>
                  <li><Link to="/terms" className="text-gray-300 hover:text-rose-primary transition-colors">Terms of Service</Link></li>
                  <li><Link to="/privacy" className="text-gray-300 hover:text-rose-primary transition-colors">Privacy Policy</Link></li>
                </ul>
              </div>
              {/* Contact */}
              <div>
                <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
                <div className="space-y-2">
                  <a href="mailto:hello@gifterschoice.app" className="flex items-center space-x-2 text-gray-300 hover:text-rose-primary transition-colors">
                    <SafeIcon icon={FiMail} className="text-sm" />
                    <span>hello@gifterschoice.app</span>
                  </a>
                </div>
              </div>
            </div>
            {/* Bottom Bar */}
            <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between">
              <div className="text-gray-400 text-sm mb-4 md:mb-0">
                © 2024 Gifter's Choice. All rights reserved.
              </div>
              <div className="flex items-center space-x-1 text-gray-400 text-sm">
                <span>Made with</span>
                <SafeIcon icon={FiHeart} className="text-rose-primary text-sm" />
                <span>for better gift giving</span>
              </div>
            </div>
          </div>
        </footer>
      );
    };

    export default Footer;